// src/ProductDetail.js (updated)
import React from "react";
import { useParams } from "react-router-dom";

function ProductDetail() {
    // Define the product data (You should ideally move this to a separate file later)
    const products = [
        { id: 1, name: "Eco-Friendly Mug", price: 15.0, image: "mug.jpg" },
        { id: 2, name: "Wireless Charger", price: 35.5, image: "charger.jpg" },
        {
            id: 3,
            name: "Noise-Cancelling Headphones",
            price: 199.99,
            image: "headphones.jpg",
        },
    ];

    const { id } = useParams();
    const productId = parseInt(id);

    // Use .find() to get the matching product object
    const product = products.find((p) => p.id === productId);

    // Handle case where product is not found
    if (!product) {
        return (
            <div className="container mt-5">
                <h1>Product Not Found!</h1>
            </div>
        );
    }

    // Use the product object to render details
    return (
        <div className="container mt-5">
            <div
                className="card shadow p-4 mx-auto"
                style={{ maxWidth: "500px" }}
            >
                {/* Placeholder for imported image files */}
                <img
                    src={product.image}
                    alt={product.name}
                    className="card-img-top mx-auto"
                    style={{ maxWidth: "300px" }}
                />
                <div className="card-body text-center">
                    <h1 className="card-title display-4">{product.name}</h1>
                    <p className="card-text fs-3">
                        Price: ${product.price.toFixed(2)}
                    </p>
                </div>
            </div>
        </div>
    );
}

export default ProductDetail;
